import { defineComponent as _defineComponent } from 'vue'
import TileCard from '@/app/components/common/boxGrid/TileCard.vue';
import { useAuthStore } from '@/app/store/authStore';
import { AuthorityType, ClientRiskProfileReport, PaginatedParams } from 'ah-api-gateways';
import { VCol } from 'ah-common-lib/src/common/components';
import { VRow } from 'ah-common-lib/src/common/components';
import LoadingOverlay from 'ah-common-lib/src/common/components/overlays/LoadingOverlay.vue';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { computed, ref, watch } from 'vue';
import CreditLimitsOnForwardsAndOptions from 'ah-trades/src/components/creditAndMarkToMarket/CreditLimitsOnForwardsAndOptions.vue';
import YourMTMPosition from 'ah-trades/src/components/creditAndMarkToMarket/YourMTMPosition.vue';
import OpenPositionsMtmListing from 'ah-trades/src/components/creditAndMarkToMarket/OpenPositionsMtmListing.vue';
import NoAvailableMarkToMarket from 'ah-trades/src/components/creditAndMarkToMarket/NoAvailableMarkToMarket.vue';
import { useWalletsStore } from '@/app/store/walletsModule';
import { ErrorExclamationIcon } from 'ah-common-lib/src/icons/components';
import { WarningExclamationIcon } from 'ah-common-lib/src/icons/components';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreditAndMarkToMarketManagement',
  setup(__props) {

const oboClientId = useOnBehalfOf();

const requestManager = useRequestManager().manager;

const walletStore = useWalletsStore();

const authStore = useAuthStore();

const clientId = computed(() => oboClientId.value?.id ?? authStore.loggedInIdentity?.client?.id);

const canSeeTrades = computed(() => authStore.hasAuthorities(AuthorityType.VIEW_TRADES));

const clientRiskProfileReportData = computed<ClientRiskProfileReport | null>(() => {
  if (clientId.value) {
    return walletStore.getClientRiskProfile(clientId.value);
  }
  return null;
});

const isMTMNegative = computed(
  () => clientRiskProfileReportData.value && clientRiskProfileReportData.value.collateralProfile.totalMarkToMarket < 0
);

const isMTMGreaterThanVMLimit = computed(
  () =>
    clientRiskProfileReportData.value &&
    Math.abs(clientRiskProfileReportData.value.collateralProfile.totalMarkToMarket) >
      clientRiskProfileReportData.value.collateralProfile.variationMarginAmount
);

const isVMLimitAndMTMZeroAmount = computed(
  () =>
    clientRiskProfileReportData.value?.collateralProfile.totalMarkToMarket === 0 &&
    clientRiskProfileReportData.value.collateralProfile.variationMarginAmount === 0
);

const defaultSortAndPageParams: Partial<PaginatedParams> = {
  sort: 'gbpPositionMtm',
  sortDirection: 'ASC',
};

function loadClientRiskProfileReport() {
  if (!clientId?.value) {
    throw 'Cannot load client risk profile report with incomplete data';
  }

  return requestManager.newPromise(
    'loadClientRiskProfileReport',
    walletStore.loadClientRiskProfile({ force: true, clientId: clientId.value })
  );
}

watch(
  clientId,
  () => {
    if (clientId.value) {
      loadClientRiskProfileReport();
    }
  },
  { immediate: true }
);

/**
 * This will guarantee that the Your Mark-to-Market Position's component always has
 * the same height as Credit Limits on Forward & Options' component since it will 'inherit' is height
 */
const creditLimitsOnForwardsAndOptionsHeight = ref<number>(0);

const getComponentHeight = (newHeight: number) => {
  creditLimitsOnForwardsAndOptionsHeight.value = newHeight;
};

return { __sfc: true,oboClientId, requestManager, walletStore, authStore, clientId, canSeeTrades, clientRiskProfileReportData, isMTMNegative, isMTMGreaterThanVMLimit, isVMLimitAndMTMZeroAmount, defaultSortAndPageParams, loadClientRiskProfileReport, creditLimitsOnForwardsAndOptionsHeight, getComponentHeight, TileCard, VCol, VRow, LoadingOverlay, CreditLimitsOnForwardsAndOptions, YourMTMPosition, OpenPositionsMtmListing, NoAvailableMarkToMarket, ErrorExclamationIcon, WarningExclamationIcon }
}

})